import myAuthorizationMaskIndexes from "@/plugin/my-authorization-mask-indexes";
import Vue from 'vue'
Vue.mixin({
    methods: {
        maskValue(section, operation){
            return myAuthorizationMaskIndexes.CRUD(section, operation)
        }
    }
})
